const widthRef = 1920
const heightRef = 1080

export const createDOM = (tag, className, text) => {
  const el = document.createElement(tag)
  if (className) el.className = className
  if (text) el.appendChild(document.createTextNode(text))
  return el
}

export const addClass = (el, className) => {
  const classList = el.className.split(' ')
  if (classList.includes(className)) return
  classList.push(className)
  el.className = classList.filter(c => c !== ' ').join(' ')
}

export const removeClass = (el, className) => {
  const classList = el.className.split(' ').filter(name => name !== className)
  el.className = classList.join(' ')
}

export const hasClass = (el, className) => {
  return el.className.split(' ').includes(className)
}

export const createLogo = (el, classPrefix) => {
  const blackBlock = createDOM('p', `${classPrefix}__black-block`)
  const isLarge = index => index > 0 && index < 6
  const c = `${classPrefix}__letter`
  const createLetter = (letter, index) => {
    const className = `${c} ${c}${isLarge(index) ? '--large' : '--medium'} text__intro-${isLarge(index) ? 'large' : 'medium'}`
    return createDOM('span', className, letter)
  }
  let letters = Array.from('hblackissem', createLetter)
  el.appendChild(letters[0])
  el.appendChild(blackBlock)
  letters.slice(1, 6).map(letter => blackBlock.appendChild(letter))
  letters.slice(6).map(letter => el.appendChild(letter))
  return letters
}

export const createSVGLogo = (el, classPrefix) => {
  const letters = []
  const paths = [
    'M251.8,42.4H199V31.5h20.1V10.9H199V0h52.7v10.9h-23.5v20.5h23.5V42.4z',
    'M251.8,231.6v10.9H199v-10.9H251.8z',
    'M235.5,354.6c2.4-0.3,4.2-1,5.4-2c2.2-1.8,3.3-5,3.3-9.4c0-2.7-0.3-4.8-0.9-6.5c-1.1-3.1-3.1-4.7-6.1-4.7c-1.7,0-3.1,0.8-4,2.3c-0.9,1.5-1.8,4-2.5,7.3l-1.3,5.7c-1.2,5.6-2.6,9.5-4,11.6c-2.4,3.6-6.2,5.3-11.4,5.3c-4.7,0-8.6-1.7-11.8-5.2c-3.1-3.5-4.7-8.6-4.7-15.3c0-5.6,1.5-10.4,4.4-14.4c2.9-4,7.2-6.1,12.8-6.2v10.6c-3.2,0.2-5.4,1.6-6.8,4.3c-0.9,1.8-1.3,3.9-1.3,6.6c0,2.9,0.6,5.2,1.7,7s2.7,2.6,4.8,2.6c1.9,0,3.3-0.9,4.2-2.6c0.6-1.1,1.3-3.4,2.2-7l2.2-9.3c1-4.1,2.2-7.1,3.8-9.1c2.5-3.1,6.1-4.7,10.8-4.7c4.8,0,8.8,1.9,12,5.6c3.2,3.7,4.8,9,4.8,15.8c0,6.9-1.6,12.4-4.7,16.4c-3.1,4-7.4,6-12.9,6V354.6z',
    'M235.5,475.1c2.4-0.3,4.2-1,5.4-2c2.2-1.8,3.3-5,3.3-9.4c0-2.7-0.3-4.8-0.9-6.5c-1.1-3.1-3.1-4.7-6.1-4.7c-1.7,0-3.1,0.8-4,2.3c-0.9,1.5-1.8,4-2.5,7.3l-1.3,5.7c-1.2,5.6-2.6,9.5-4,11.6c-2.4,3.6-6.2,5.3-11.4,5.3c-4.7,0-8.6-1.7-11.8-5.2c-3.1-3.5-4.7-8.6-4.7-15.3c0-5.6,1.5-10.4,4.4-14.4c2.9-4,7.2-6.1,12.8-6.2v10.6c-3.2,0.2-5.4,1.6-6.8,4.3c-0.9,1.8-1.3,3.9-1.3,6.6c0,2.9,0.6,5.2,1.7,7s2.7,2.6,4.8,2.6c1.9,0,3.3-0.9,4.2-2.6c0.6-1.1,1.3-3.4,2.2-7l2.2-9.3c1-4.1,2.2-7.1,3.8-9.1c2.5-3.1,6.1-4.7,10.8-4.7c4.8,0,8.8,1.9,12,5.6c3.2,3.7,4.8,9,4.8,15.8c0,6.9-1.6,12.4-4.7,16.4c-3.1,4-7.4,6-12.9,6V475.1z',
    'M208.4,563.6v27.9h11.2v-25.6h9.2v25.6h13.6v-29.2h9.5v40H199v-38.7H208.4z',
    'M199,700.7v-15.9h52.7v10.3h-35.7c-1,0-2.5,0-4.3,0c-1.8,0-3.3,0-4.3,0l44.3,10v10.7l-44.3,9.9c1,0,2.4,0,4.3,0c1.8,0,3.3,0,4.3,0h35.7v10.3H199v-16l41.5-9.6L199,700.7z',
    'M399.5,97.9h16.3v32.6l30.6-32.6h21.4l-32.5,32.6l34.2,46.6h-21.3l-24.4-34.6l-8,8.1v26.5h-16.3V97.9z',
    'M303.4,106.2c6.4-6.5,14.5-9.8,24.3-9.8c13.2,0,22.8,4.4,28.9,13.1c3.4,4.9,5.2,9.8,5.4,14.8h-16.5c-1.1-3.8-2.4-6.7-4.1-8.6c-2.9-3.4-7.3-5.2-13.1-5.2c-5.9,0-10.5,2.4-13.9,7.3c-3.4,4.9-5.1,11.7-5.1,20.6c0,8.9,1.8,15.5,5.4,20c3.6,4.4,8.2,6.6,13.7,6.6c5.7,0,10-1.9,13-5.7c1.6-2,3-5.1,4.1-9.2h16.4c-1.4,8.6-5,15.6-10.9,21.1c-5.8,5.4-13.3,8.1-22.4,8.1c-11.3,0-20.1-3.7-26.6-11c-6.4-7.3-9.7-17.4-9.7-30.2C292.4,124.3,296,113.7,303.4,106.2z',
    'M217,97.9h18.7l28,79.2h-17.9l-5.2-16.3h-29.2l-5.4,16.3h-17.3L217,97.9z M215.9,147.2h20.3l-10-31.2L215.9,147.2z',
    'M103.2,97.9h16.5v64.9h39.5v14.2h-56.1V97.9z',
    'M58.8,106.4c2.4,3.4,3.6,7.4,3.6,12.1c0,4.8-1.2,8.7-3.7,11.7c-1.4,1.6-3.4,3.2-6,4.5c4,1.5,7.1,3.8,9.1,7c2.1,3.2,3.1,7.1,3.1,11.6c0,4.7-1.2,8.9-3.5,12.6c-1.5,2.5-3.4,4.5-5.6,6.2c-2.5,1.9-5.5,3.3-8.9,4c-3.4,0.7-7.2,1.1-11.2,1.1H0V97.9h38.3C47.9,98.1,54.8,100.9,58.8,106.4z M15.8,111.7v17.5H35c3.4,0,6.2-0.7,8.4-2c2.1-1.3,3.2-3.6,3.2-7c0-3.7-1.4-6.1-4.3-7.3c-2.4-0.8-5.6-1.2-9.4-1.2H15.8z M15.8,142.2v21.1H35c3.4,0,6.1-0.5,8-1.4c3.5-1.7,5.2-5,5.2-9.9c0-4.1-1.7-6.9-5-8.5c-1.9-0.9-4.5-1.3-7.9-1.3H15.8z'
  ]
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  svg.setAttribute('class', 'BM-Logo')
  svg.setAttribute('x', '0px')
  svg.setAttribute('y', '0px')
  svg.setAttribute('width', '469.4px')
  svg.setAttribute('height', '735.9px')
  svg.setAttribute('version', '1.1')
  let pathDOM
  paths.map(path => {
    pathDOM = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    pathDOM.setAttributeNS(null, 'class', 'BM-Logo__letter')
    pathDOM.setAttributeNS(null, 'd', path)
    pathDOM.setAttributeNS(null, 'style', 'fill:#ffffff')
    svg.appendChild(pathDOM)
    letters.push(pathDOM)
    return pathDOM
  })
  el.appendChild(svg)
  return { svg, letters }
}

export const docHTML = document.getElementsByTagName('html')[0]

export const getRotateCSS = function (x, y, z, degree) {
  return `rotateX(${x * degree}deg) rotateY(${y * degree}deg) rotateZ(${z * degree}deg)`
}

export const getScreenRatio = function () {
  return Math.min(window.innerWidth / widthRef, window.innerHeight / heightRef)
}

export const setBodyRatioFontSize = function (widthRef, heightRef) {
  docHTML.style.fontSize = `${getScreenRatio() * 10}px`
}

export const updateSpriteSheet = function (el, width, numFrame) {
  const unit = width.slice(-1) === '%' ? '%' : 'px'
  el.style.backgroundPositionX = `${Math.round(numFrame) * - parseFloat(width)}${unit}`
}


// WEBPACK FOOTER //
// ./src/scripts/helpers/DOMHelper.js